<template>
  <div id="level-up-modal" class="pt-4">
    <slot name="modal-header" :titleText="$t('app.general.texts.general.levelUpText')" :hasExit="true" :hasSeparator="false"></slot>
    <div class="row no-gutters first-part px-4 pt-3 pb-4">
      <div class="col-12">
        <div class="paragraph16">
          {{$t('app.general.texts.general.earnAtLeastOneHundredStarsPtOne', {starCount: thematicsByLevel.starsForChangeLevel})}}
        </div>
      </div>
      <div class="col-12" style='padding-top:14.6px'>
        <div class="row no-gutters">
          <rounded-button
            :text="'app.general.texts.general.startLevelSkipTest'"
            :fontSize="'16px'"
            :fontWeight="'bold'"
            :isOutline="false"
            :color="'var(--primaryBlue)'"
            class="test-start-button"
            @roundedButtonClicked="startLevelSkipTest"
          />
        </div>
      </div>
    </div>
    <div class="row no-gutters second-part bg-black py-4">
        <div class="icon-crown mx-auto">
          <img src="/static/img/icons/pro-label.svg">
        </div>
          <div class='row no-gutters justify-content-center px-4' style='padding-top:15px'>
            <div class="title1">{{$t('app.general.texts.general.levelUpWithoutTest')}}</div>
          </div>
        <div class="paragraph16 become-pro-user">
          <span v-html="$t('app.general.texts.general.becomeProUser')"></span>
        </div>
        <div :style="getWindowWidthMobile ? '' : 'position:absolute;bottom:40px;width:100%;'">
      <div class="col-12 px-4">
        <div class="try-free">
          <span class="button-label">
            {{getButtonLabel}}
          <inline-link v-if="hasDiscount" class="more-about-price" :text="$t('app.priceCommunication.link.text')" @inlineLinkClicked="openPriceCommunication(product)"/>
          </span>
        </div>
      </div>
      <div class="col-12 px-4" style="padding-bottom: 25px;">
        <div class="row no-gutters more-info-button-row" :style="hasDiscount ? 'position:relative' : ''">
          <rounded-button
            class="more-info-button"
            :text="getOkButtonText"
            :isTextVhtml="isOkButtonTextHtml"
            :state="isLoading ? 'loading' : 'enabled'"
            :fontSize="'16px'"
            :fontWeight="'bold'"
            :color="'#fab62f'"
            :iconName="''"
            @roundedButtonClicked="moreInformation"
          />
          <discount-label v-if='hasDiscount' :text="getDiscountPercentageText" :rotateValue='5' :textColor="'#333333'" :padding='"0 0 0 10px"' :labelHeight="31" :labelWidth="75" :rightSideBackgroundColor='"white"' :isRotated="true" :isLeftSide="false" class='label' />
        </div>
      </div>
      </div>
      <div class="col-12 px-4 find-out-more">
        <inline-link @inlineLinkClicked="goToPro" :text="'app.general.texts.general.levelUpWithoutTestFindOutMore'" :color="'#ffffff'"/>
      </div>
    </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import PriceCommunicationModal from '@/components/shared/elements/modal/PriceCommunicationModal';
import RoundedButton from '@/components/shared/elements/buttons/RoundedButton';
import FindOutMorePro from '@/components/modules/island/components/FindOutMorePro';
import DiscountLabel from '@/components/shared/elements/modal/DiscountLabel';
import ShimmingLine from '@/components/shared/elements/shimming/ShimmingLine';
import ProductsContentMixin from '@/components/shared/elements/mixins/ProductsContentMixin';
import InlineLink from '@/components/shared/elements/buttons/InlineLink';

// import IslandLevelSkip from './IslandLevelSkip';

export default {
  name: 'IslandLevelUpModal',
  mixins: [ProductsContentMixin],
  components: {
    'rounded-button': RoundedButton,
    'shimming-line': ShimmingLine,
    DiscountLabel,
    'inline-link': InlineLink,
    PriceCommunicationModal,
  },
  props: {
    level: {
      type: [String, Number],
      required: false,
    },
    okText: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      thematicsByLevel: 'contents/thematicsByLevel',
      getWindowWidthMobile: 'settings/getWindowWidthMobile',
    }),
  },
  methods: {
    ...mapActions({
      getProduct: 'subscriptions/getProduct',
      getUserProfile: 'users/getUserProfile',
    }),
    openPriceCommunication(product) {
      this.$eventBus.showModal({
        bind: {
          is: PriceCommunicationModal,
          product,
          monthlyProduct: this.currentProducts[0],
          currency: this.currency,
          discountText: `${this.product.discountPercentage}%`,
        },
      });
    },
    closeModal() {
      this.$eventBus.closeModal();
    },
    startLevelSkipTest() {
      this.$eventBus.closeModal();
      this.$router.push(`lessons/level/${this.level}`);
    },
    goToPro() {
      this.$router.push('/pro/');
      this.$eventBus.closeModal();
      // this.$eventBus.showModal({
      //   bind: {
      //     is: FindOutMorePro,
      //     level: this.level,
      //     isOkButtonTextHtml: this.isOkButtonTextHtml,
      //     product: this.product,
      //     countryPrice: this.getCountryPrice,
      //     okBtnText: this.usedTrial ? this.getOkButtonText : this.$t('app.findOutMorePro.startFreeTrial'),
      //     okAction: this.moreInformation,
      //     buttonLabel: this.getButtonLabel,
      //     hasDiscount: this.hasDiscount,
      //     discountPercentAge: this.hasDiscount ? this.getDiscountPercentageText : '',
      //   },
      // });
    },
    moreInformation() {
      // gtag measurement point
      if (this.$gtag) {
        this.$gtag.event('Step Level', {
          event_category: 'PRO offer',
        });
      }
      this.$router.push({ name: 'ShopScreen' });
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
#level-up-modal {
  width: 312px;
  .bg-black {
    padding-top: 29px !important;
  }
  /deep/ .icon-crown {
    height: 27px;
    width: auto;
    display: flex;
    justify-content: center;
  }
  .first-part {
    background-color: var(--white);
    padding-bottom: 24px !important;
    padding-top: 14px !important;
    color: var(--terraGrey);
    line-height: 1.38;
    .cls-1 {
      fill: var(--yellow);
      stroke: var(--sunflower);
      stroke-miterlimit: 10;
    }
    svg {
      width: 17px;
      height: 16px;
    }
    .test-start-button {
      /deep/ .btn-text {
        padding-top: 12px;
        padding-bottom: 12px;
      }
    }
  }
  .second-part {
    min-height: 331px;
    background-image: linear-gradient(to bottom, #3B91CC, #24587c);
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    line-height: 1.2;
    display: flex;
    flex-direction: column;
    .crown {
      padding: 24px 0 10px 0;
      display: block;
      text-align: center;
      svg {
        width: 76.5px;
      }
    }
    .title1 {
      text-align: center;
      font-family: Roboto;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: var(--white);
    }
    .paragraph16 {
      padding: 0 0 20px 0;
      line-height: 1.19;
      text-align: center;
      font-family: Roboto;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.38;
      letter-spacing: normal;
      text-align: center;
      color: var(--white);
    }
    .try-free {
      font-family: Roboto;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: center;
      color: var(--white);
      padding-right: 6px;
      padding-left: 6px;
    // padding-bottom: 14px;
    }
    .find-out-more {
      cursor: pointer;
      position: absolute;
      bottom: 23px;
      text-decoration: underline;
      font-family: Roboto;
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: normal;
      text-align: center;
      color: var(--white);
    }
    .cls-1 {
      fill: #f2ce5c;
    }

    .cls-2 {
      fill: #e7c545;
    }

    .cls-3 {
      fill: var(--white);
    }
  }
  .more-info-button {
    /deep/ .btn-text {
      padding-top: 10px;
      padding-bottom: 10px;
    }
    /deep/ .btn {
      border-width: 1px !important;
    }
  }
}

.more-about-price {
  height: 16px !important;
  margin: 0 auto 8px auto;
  width: fit-content;
  /deep/ .link {
    font-size: 12px;
    line-height: 1;
    font-weight: normal;
    color: var(--white) !important;
  }
  :hover {
    text-decoration: unset !important;
  }
}

.become-pro-user{
  padding: 8px 32px 16px 32px !important;
}
 .label{
    position: absolute;
    top: -12px;
    right: -23px;
  }
  .more-info-button-row{
    height: 44px;
  }

@media (max-width: $medium-screen) {
  #level-up-modal {
    width: unset;
    .second-part {
      padding-bottom: 0px !important;
      display: block;
      min-height: unset;
      max-height: 180px;
      overflow-y: scroll;
      .find-out-more {
        position: relative;
        padding-top: 32px;
      }
      .label {
        zoom: 0.8 !important;
      }
    }
  }
}
</style>
